import { Requests } from "@/services/requests";

const ENDPOINTS = {
   BASE: "payment/org/"
};

const MSG = {
   CREATE_SUCCESS: "Criado com sucesso",
   GET_ALL_SUCCESS: "Retornados com sucesso",
   ERROR_DEFAULT: "Erro ao fazer a requisição"
};
export default class Plans {
   constructor(request) {
      this.request = request;
      this.moduleName = "plans";
      this.routes = {
         list: {
            get: this.listPlans.bind(this)
         }
      };
   }
   async makeRequest({ url, method, body, headers, expectedStatus }) {
      return Requests[method]({ url, body, headers }, expectedStatus);
   }

   async listPlans(organization) {
      return this.makeRequest({
         url: `${ENDPOINTS.BASE}${organization}/plans/public/`,
         method: "GET",
         expectedStatus: {
            200: MSG.GET_ALL_SUCCESS,
            default: MSG.ERROR_DEFAULT
         }
      });
   }
}
